import './Digital_Brain_Research.css';
import brain2 from './brain-2.jpg';    
import Navbar from './Navbar.js';
import brain3 from './brain-3.jpg';  
import Footer from './footer.js';
import video_brain from './brain-2.mp4';
import video_brain2 from './brain-3.mp4';

const Digital_Brain_Research = () => {
  return (
    <div className="research-page">
       <Navbar />
       <h1>Cnyda Dynamics Research Division</h1>
      <main className="research-article">
        <div className="research-block">
          <h2 className="main-heading">Rational Brain Research:</h2>
          <p className="description">
            Exploring the mathematical foundations of rational brain structure through the lens of the Philosophy of mind. 
            This research is inspired by the philosophical ideas of Rene Descartes, specifically his concept of a rational brain structure, 
            the rational brain is a distinct cognitive structure within the AI avatar, providing logical and rational connections to the empirical brain, 
            thereby facilitating the thinking process.
          </p>
            <video 
                src={video_brain} 
                className="article-image" 
                autoPlay 
                loop 
                muted 
                playsInline
              />
        </div>

        <div className="research-block">
          <h2 className="main-heading">Cognitive Brain Research:</h2>
          <p className="description">Currently studying cognitive-behavioral sciences to gain a deeper understanding of the psychological processes that underlie human thought and behavior. 
            Specifically, the company is interested in exploring the intricate mechanisms that govern the generation of thoughts and the cognitive processes that shape our perceptions, beliefs, 
            and actions.</p>
            <video 
              src={video_brain2} 
              className="article-image" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
        </div>
      </main> 
      <Footer />
    </div>
  );
};

export default Digital_Brain_Research;